import React, { useState } from "react";

import classNames from "classnames";

import { TeamRatings, TeamTypes } from "../types/coachreview";

import { StarIcon } from "../../../../lib/icons";
import { ITeamRating } from "../../../../types/api";
import { useCoachReviewContext } from "../contexts/CoachReview";

interface Props {
    team: TeamTypes;
    ratedTeam: ITeamRating | undefined;
    ratingCategory: keyof TeamRatings;
}

const Stars = ({ team, ratedTeam, ratingCategory }: Props) => {
    const [hoveredStars, setHoveredStars] = useState<number>(0);
    const currentTeamRatingIndividual = ratedTeam?.ratings || undefined;
    const { tempRating, handleStarClick } = useCoachReviewContext();

    return [1, 2, 3, 4, 5].map(idx => (
        <StarIcon
            key={idx}
            className={classNames({
                icon: true,
                "fa-xl": true,
                rated:
                    currentTeamRatingIndividual?.[ratingCategory] &&
                    currentTeamRatingIndividual[ratingCategory] >= idx,
                hovered: idx <= hoveredStars,
                unrated: idx > hoveredStars && hoveredStars !== 0,
            })}
            onMouseEnter={() => setHoveredStars(idx)}
            onMouseLeave={() =>
                setHoveredStars(tempRating?.[team]?.[ratingCategory] || 0)
            }
            onClick={() => handleStarClick(team, ratingCategory, idx)}
        />
    ));
};

export default Stars;
